import { Component, Input, OnInit, inject } from '@angular/core';
import { Capture } from '../../../core/models/capture.model';
import { ClientConsultNoteVerificationsService } from '../../../core/services/client-consult-note-verifications.service';

import { FormsModule } from '@angular/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-capture-consult-note-verification',
    templateUrl: './capture-consult-note-verification.component.html',
    imports: [FormsModule, FaIconComponent]
})
export class CaptureConsultNoteVerificationComponent implements OnInit {
  private clientConsultNoteVerificationsService = inject(ClientConsultNoteVerificationsService);

  @Input() capture: Capture;

  verification = null;
  loading = false;

  ngOnInit() {
    this.loading = true;
    this.clientConsultNoteVerificationsService.getByCapture(this.capture.id).subscribe(verification => {
      this.loading = false;
      this.verification = verification;
    });
  }
}
